<template>
  <div class="MenuPanel">
    <div
      class="Menu__panel"
      :style="[
                functionalityStyle,
                positionStyle,
                (isTranslating) ? transitionStyle : {}
            ]"
    >
      <div v-if="list.title" @click="handleHeaderClicked" class="Menu__header">
        <BaseIcon class="menu__icon" name="chevron_left" size="24"></BaseIcon>
        {{ list.title }}
      </div>

      <ul class="Menu__list">
        <li
          v-for="item in list.children"
          :key="item.title"
          @click="handleItemClicked(item)"
          class="Menu__item"
        >
          <div>{{ item.title }}</div>
          <!-- <span v-show="item.children.length > 0"> -->
          <BaseIcon
            class="menu__arrow"
            name="arrow_forward"
            size="18"
            v-if="item.children.length > 0"
          ></BaseIcon>
          <!-- </span> -->
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import BaseIcon from '../../../elements/BaseIcon.vue'
export default {
  components: { BaseIcon },
  props: {
    list: {
      type: Object,
      required: true
    },
    positionStyle: {
      type: Object,
      required: true
    },
    showHeaderArrow: {
      type: Boolean,
      default: false
    },
    isTranslating: {
      type: Boolean,
      default: false
    },
    handleHeaderClicked: {
      type: Function,
      default: () => {}
    },
    handleItemClicked: {
      type: Function,
      default: () => {}
    },
    functionalityStyle: {
      type: Object,
      required: true
    },
    transitionStyle: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="postcss">
.Menu__panel {
  @apply flex flex-col min-h-full;
}
.nav__share {
  @apply flex-1 flex flex-col justify-end;
}
.nav__share-wrapper {
  @apply w-full flex px-4 pt-4 pb-12 bg-white;
}
.nav__share-button {
  @apply text-white fill-current m-1;
}
.nav__share-button:first-of-type {
  @apply ml-0;
}
.nav__share-button:last-of-type {
  @apply mr-0;
}
.menu__icon {
  @apply p-0 pr-1 m-0;
}
.menu__arrow {
  @apply fill-current;
}
.MenuPanel ul {
  @apply p-0 m-0;
}
.MenuPanel li {
  @apply p-4 no-underline font-semibold border border-t-0 border-l-0 border-r-0 border-body-lighter;
}
.Menu__header {
  @apply p-4 pt-6 pb-5 flex items-center cursor-pointer border border-t-0 border-l-0 border-r-0 border-body-lighter text-secondary;
}
.Menu__list {
  @apply;
}
.Menu__list .separator {
  @apply m-0 pt-1;
}
.Menu__item {
  @apply flex justify-between items-center cursor-pointer text-secondary;
}
.Menu__item:first-of-type {
  @apply pt-6;
}
.Menu__header + .Menu__list .Menu__item:first-of-type {
  @apply pt-4;
}
.Menu__header:hover,
.Menu__item:hover {
  @apply bg-body-lightest;
}
.Menu__item div {
  @apply text-primary;
}
@screen sm {
  .Menu__header,
  .MenuPanel li {
    @apply py-6 px-6;
  }
}
</style>
